var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_UserFollowerView',{attrs:{"header-text":_vm.$t('users.title-followers')}},[(_vm.module)?_c('Users_Feed',{attrs:{"module":_vm.module,"no-results-message":_vm.$t('users.no-followers')}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }